import React, { Suspense, useCallback } from 'react'
import { PlaceWorld } from '@fs/zion-icon'
import { useOverlay } from '@fs/zion-ui'
import { trackEvent } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import HeaderIconButton from '../HeaderIconButton/HeaderIconButton'

const LangPicker = React.lazy(() => import('@fs/zion-lang-picker'))

export default function LanguagePicker() {
  const overlay = useOverlay()
  const { t } = useTranslation()
  const buttonTitle = t('header.lang-picker.action', 'Select a Language')
  const openLanguagePicker = useCallback(
    (event) => {
      overlay.open(event)
      trackEvent({ event_name: 'header:languagePicker:clicked' })
    },
    [overlay]
  )

  return (
    <Suspense fallback={<HeaderIconButton Icon={PlaceWorld} title={buttonTitle} />}>
      <HeaderIconButton Icon={PlaceWorld} title={buttonTitle} onClick={openLanguagePicker} />
      {overlay.isOpen && <LangPicker overlay={overlay} />}
    </Suspense>
  )
}
